/* Section nav (PRO system) — sections/cs-subnav.liquid
   Marks the link for the section currently under the header + nav as active
   (aria-current), keeps it scrolled into view on small screens, and shares
   the nav's height (--cs-subnav-height) so anchor links land below it. */
if (!customElements.get('cs-subnav')) {
  customElements.define(
    'cs-subnav',
    class CsSubnav extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-target]')];
        this.targets = this.links.map((link) => document.getElementById(link.dataset.target));
        this.list = this.querySelector('.cs-subnav__list');

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        this.onResize = () => {
          document.documentElement.style.setProperty('--cs-subnav-height', `${this.offsetHeight}px`);
          this.update();
        };

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.onResize();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      update() {
        // The active section is the last one whose top is above a line a
        // quarter of the way down the screen (below the nav). Near the end of
        // the page, the last section wins.
        const navBottom = this.getBoundingClientRect().bottom;
        const line = navBottom + (window.innerHeight - navBottom) * 0.25;
        const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        let active = -1;
        this.targets.forEach((target, index) => {
          if (target && target.getBoundingClientRect().top <= line) active = index;
        });
        if (atBottom) {
          const last = this.targets.findLastIndex((target) => target);
          if (last > -1 && this.targets[last].getBoundingClientRect().top < window.innerHeight) active = last;
        }

        this.links.forEach((link, index) => {
          const isActive = index === active;
          if (isActive && link.getAttribute('aria-current') !== 'true') {
            const box = link.getBoundingClientRect();
            const listBox = this.list.getBoundingClientRect();
            const gutter = parseFloat(getComputedStyle(this.list).paddingLeft) || 0;
            if (box.left < listBox.left + gutter || box.right > listBox.right - gutter) {
              const left = box.left - listBox.left + this.list.scrollLeft - gutter;
              this.list.scrollTo({ left, behavior: 'smooth' });
            }
          }
          link.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }
  );
}
